import React from 'react';
import PropTypes from 'prop-types';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';

import Model from '../api/Model';
import LoadingButton from './utils/LoadingButton';


@observer
class DeleteDialog extends React.Component {
  @observable open = false;
  @observable submitting = false;

  static propTypes = {
    instance: PropTypes.instanceOf(Model).isRequired,
    onUpdate: PropTypes.func,
    triggerFunc: PropTypes.func,
  };

  static defaultProps = {
    onUpdate: null,
    triggerFunc: null,
  };

  handleOpen = () => {
    this.open = true;
  };

  handleClose = () => {
    this.open = false;
  };

  get trigger() {
    const { triggerFunc } = this.props;
    if (triggerFunc === null) {
      return <Button onClick={this.handleOpen}>Delete</Button>;
    }
    return triggerFunc(this.handleOpen);
  }

  handleDelete = async () => {
    const { instance, onUpdate } = this.props;
    this.submitting = true;
    try {
      await instance.delete();
    } finally {
      this.submitting = false;
    }
    this.handleClose();
    if (onUpdate !== null) {
      onUpdate(instance);
    }
  };

  render() {
    const { instance } = this.props;
    return (
      <>
        {this.trigger}
        <Dialog open={this.open} onClose={this.handleClose}>
          <DialogTitle>Delete “{instance.toString()}”?</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to delete “{instance.toString()}”?
            </DialogContentText>
            <DialogContentText>
              It’s a permanent action, you cannot revert it.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose}>Cancel</Button>
            <LoadingButton
              onClick={this.handleDelete}
              color="secondary"
              loading={this.submitting}
            >
              Delete
            </LoadingButton>
          </DialogActions>
        </Dialog>
      </>
    );
  }
}


export default DeleteDialog;
